import React, { useState, useRef, useEffect } from 'react';

import {
  Container,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';

import { ClipLoader } from 'react-spinners';

import Swal from 'sweetalert2';

import { useSearchParams } from 'react-router-dom';

import { getBookings } from '../../components/Api/GmsBooking';

import { getCustomers } from '../../components/Api/GmsCustomer';

import { signBookingConsent } from '../../components/Api/GmsBooking';

import { getEmployees } from '../../components/Api/GmsEmployee';

import Breadcrumb from '../../components/Common/Breadcrumb';



const ConsentFormPage = () => {

  const [searchParams] = useSearchParams();

  const bookingId = searchParams.get('bookingId');

  

  const [witnessName, setWitnessName] = useState('');

  const [guestSignature, setGuestSignature] = useState('');

  const [witnessSignature, setWitnessSignature] = useState('');

  const [isWitnessNameReadOnly, setIsWitnessNameReadOnly] = useState(false);

  

  const [customerName, setCustomerName] = useState('');

  const [customerMobile, setCustomerMobile] = useState('');

  const [isConsentSigned, setIsConsentSigned] = useState(false);

  const [consentSignedDate, setConsentSignedDate] = useState(null);

  const [witnessNameFromDb, setWitnessNameFromDb] = useState('');

  const [guestSignatureFromDb, setGuestSignatureFromDb] = useState('');

  const [witnessSignatureFromDb, setWitnessSignatureFromDb] = useState('');

  

  const [loading, setLoading] = useState(false);

  const [pageLoading, setPageLoading] = useState(true);

  

  const guestCanvasRef = useRef(null);

  const witnessCanvasRef = useRef(null);

  const guestIsDrawingRef = useRef(false);

  const witnessIsDrawingRef = useRef(false);



  useEffect(() => {

    if (bookingId) {

      loadBookingData();

    } else {

      Swal.fire("Error", "Booking ID is required", "error").then(() => {

        window.close();

      });

    }

  }, [bookingId]);





  useEffect(() => {

    // Initialize canvas when component mounts or data changes

    if (!pageLoading) {

      setTimeout(() => {

        initializeCanvas(guestCanvasRef.current);

        initializeCanvas(witnessCanvasRef.current);



        // If viewing signed consent, load signatures

        if (isConsentSigned) {

          if (guestSignatureFromDb) {

            loadSignatureToCanvas(guestCanvasRef.current, guestSignatureFromDb);

          }

          if (witnessSignatureFromDb) {

            loadSignatureToCanvas(witnessCanvasRef.current, witnessSignatureFromDb);

          }

        }

      }, 100);

    }

  }, [pageLoading, isConsentSigned, guestSignatureFromDb, witnessSignatureFromDb]);



  const loadBookingData = async () => {

    try {

      setPageLoading(true);

      if (!bookingId) {
        throw new Error("Booking ID is required");
      }

      const response = await getBookings({ booking_Id: parseInt(bookingId) });

      console.log("Booking API response:", response);

      // Check if response indicates an error
      if (response && response.isSuccess === false) {
        throw new Error(response.message || "Failed to fetch booking data");
      }

      // Handle both paginated response and array response (backward compatibility)

      let bookings = [];

      if (response && response.bookings) {

        // New paginated response format

        bookings = response.bookings;

      } else if (Array.isArray(response)) {

        // Old array format (backward compatibility)

        bookings = response;

      } else if (response && response.data && Array.isArray(response.data)) {

        // Another possible response format

        bookings = response.data;

      }

      console.log("Extracted bookings:", bookings);

      

      if (bookings && bookings.length > 0) {

        const booking = bookings[0];

        

        // Set consent status

        setIsConsentSigned(booking.isConsentSigned || false);

        setConsentSignedDate(booking.consentSignedDate);

        setWitnessNameFromDb(booking.witnessName || '');

        setGuestSignatureFromDb(booking.guestSignature || '');

        setWitnessSignatureFromDb(booking.witnessSignature || '');

        

        // Load customer data

        if (booking.customer_Id) {

          try {

            const customersResponse = await getCustomers({ customer_Id: booking.customer_Id });

            // Handle both array response and paginated response (if API changes)
            let customers = [];
            if (Array.isArray(customersResponse)) {
              customers = customersResponse;
            } else if (customersResponse && customersResponse.Items) {
              // Paginated response format
              customers = customersResponse.Items;
            } else if (customersResponse && Array.isArray(customersResponse.customers)) {
              // Another possible paginated format
              customers = customersResponse.customers;
            }

            if (customers && customers.length > 0) {

              const customer = customers[0];

              // Extract customer name and mobile - handle case where name might contain mobile
              let customerName = customer.customer_NameEn || '';
              let customerMobile = customer.customer_ContactNo || '';

              // If name contains a pattern like "Name — Mobile" or "Name - Mobile", split it
              const nameMobilePattern = /(.+?)\s*[—–-]\s*(\d+)/;
              const match = customerName.match(nameMobilePattern);
              if (match && !customerMobile) {
                customerName = match[1].trim();
                customerMobile = match[2].trim();
              }

              setCustomerName(customerName);

              setCustomerMobile(customerMobile);

            } else {

              // Customer not found, but don't fail the whole process
              console.warn("Customer not found for booking:", booking.customer_Id);
              setCustomerName('N/A');
              setCustomerMobile('N/A');

            }

          } catch (customerError) {

            // If customer loading fails, log but don't fail the whole process
            console.error("Error loading customer data:", customerError);
            setCustomerName('N/A');
            setCustomerMobile('N/A');

          }

        } else {

          // No customer ID, set defaults
          setCustomerName('N/A');
          setCustomerMobile('N/A');

        }

        

        // Set witness name if already signed

        if (booking.isConsentSigned && booking.witnessName) {

          setWitnessName(booking.witnessName);

        } else if (!booking.isConsentSigned) {

          // If not signed, try to load employee name for witness

          // This will be called after state is set

          setTimeout(() => {

            loadEmployeeNameForWitness();

          }, 100);

        }

      } else {

        Swal.fire("Error", "Booking not found", "error").then(() => {

          window.close();

        });

      }

    } catch (error) {

      console.error("Error loading booking data:", error);

      // Provide more detailed error message
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "Failed to load booking data. Please check the console for details.";

      Swal.fire("Error", errorMessage, "error").then(() => {

        window.close();

      });

    } finally {

      setPageLoading(false);

    }

  };



  const loadEmployeeNameForWitness = async () => {

    try {

      // Get user data from localStorage

      const user = JSON.parse(localStorage.getItem('user') || '{}');

      const employeeId = user.user_EmployeeId || user.employeeId;

      

      // Check if employee name is directly in user object

      if (user.employee_NameEn || user.employee_Name) {

        const employeeName = user.employee_NameEn || user.employee_Name;

        // Set witness name and make it read-only

        setWitnessName(employeeName);

        setIsWitnessNameReadOnly(true);

        return;

      }

      

      // If employee ID exists but name is not in user object, fetch from API

      if (employeeId) {

        const employees = await getEmployees({ employee_Id: employeeId });

        if (employees && employees.length > 0) {

          const employee = employees[0];

          const employeeName = employee.employee_NameEn || employee.employee_Name;

          if (employeeName) {

            // Set witness name and make it read-only

            setWitnessName(employeeName);

            setIsWitnessNameReadOnly(true);

          }

        }

      }

    } catch (error) {

      console.error("Error loading employee name for witness:", error);

      // Don't show error to user, just log it - witness name can be entered manually

    }

  };



  const initializeCanvas = (canvas) => {

    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#ffffff';

    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = '#000000';

    ctx.lineWidth = 2;

    ctx.lineCap = 'round';

    ctx.lineJoin = 'round';

  };



  const loadSignatureToCanvas = (canvas, base64String) => {

    if (!canvas || !base64String) return;

    const ctx = canvas.getContext('2d');

    const img = new Image();

    img.onload = () => {

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#ffffff';

      ctx.fillRect(0, 0, canvas.width, canvas.height);



      const hRatio = canvas.width / img.width;

      const vRatio = canvas.height / img.height;

      const ratio = Math.min(hRatio, vRatio);

      const centerShift_x = (canvas.width - img.width * ratio) / 2;

      const centerShift_y = (canvas.height - img.height * ratio) / 2;

      ctx.drawImage(img, 0, 0, img.width, img.height,

                    centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);

    };

    img.onerror = (e) => {

      console.error("Error loading signature image:", e);

      Swal.fire("Error", "Failed to load signature image. It might be corrupted or truncated.", "error");

    };

    const imageSrc = base64String.startsWith('data:') ? base64String : `data:image/png;base64,${base64String}`;

    img.src = imageSrc;

  };



  const startDrawing = (e, isGuest) => {

    if (isConsentSigned) return;

    const canvas = isGuest ? guestCanvasRef.current : witnessCanvasRef.current;

    const isDrawingRef = isGuest ? guestIsDrawingRef : witnessIsDrawingRef;



    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();

    const ctx = canvas.getContext('2d');



    isDrawingRef.current = true;

    ctx.beginPath();

    ctx.moveTo(

      e.clientX - rect.left,

      e.clientY - rect.top

    );

  };



  const draw = (e, isGuest) => {

    if (isConsentSigned) return;

    const canvas = isGuest ? guestCanvasRef.current : witnessCanvasRef.current;

    const isDrawingRef = isGuest ? guestIsDrawingRef : witnessIsDrawingRef;



    if (!isDrawingRef.current || !canvas) return;



    const rect = canvas.getBoundingClientRect();

    const ctx = canvas.getContext('2d');



    ctx.lineTo(

      e.clientX - rect.left,

      e.clientY - rect.top

    );

    ctx.stroke();

  };



  const stopDrawing = (isGuest) => {

    if (isConsentSigned) return;

    const isDrawingRef = isGuest ? guestIsDrawingRef : witnessIsDrawingRef;

    isDrawingRef.current = false;

  };



  const clearSignature = (isGuest) => {

    if (isConsentSigned) return;

    const canvas = isGuest ? guestCanvasRef.current : witnessCanvasRef.current;

    if (canvas) {

      const ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#ffffff';

      ctx.fillRect(0, 0, canvas.width, canvas.height);

    }

    if (isGuest) {

      setGuestSignature('');

    } else {

      setWitnessSignature('');

    }

  };



  const getSignatureBase64 = (canvas) => {

    if (!canvas) return '';

    return canvas.toDataURL('image/png');

  };



  // Check if canvas has any drawing (non-white pixels)

  const hasDrawing = (canvas) => {

    if (!canvas) return false;

    const ctx = canvas.getContext('2d');

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    const data = imageData.data;

    

    // Check if there are any non-white pixels (considering slight variations)

    for (let i = 0; i < data.length; i += 4) {

      const r = data[i];

      const g = data[i + 1];

      const b = data[i + 2];

      const a = data[i + 3];

      

      // If pixel is not white (or very close to white) and has some opacity, it's a drawing

      if (a > 0 && (r < 250 || g < 250 || b < 250)) {

        return true;

      }

    }

    return false;

  };



  const handleSign = async () => {

    if (isConsentSigned) {

      window.close();

      return;

    }



    // Get signatures from canvas

    const guestSig = getSignatureBase64(guestCanvasRef.current);

    const witnessSig = getSignatureBase64(witnessCanvasRef.current);



    // Check if signatures have any drawing by examining pixel data

    const isGuestSigEmpty = !guestSig || !hasDrawing(guestCanvasRef.current);

    const isWitnessSigEmpty = !witnessSig || !hasDrawing(witnessCanvasRef.current);



    // Both signatures are optional, but at least one should be provided

    if (isGuestSigEmpty && isWitnessSigEmpty) {

      Swal.fire("Warning", "Please provide at least one signature (Guest or Witness)", "warning");

      return;

    }



    try {

      setLoading(true);

      const consentData = {

        booking_Id: parseInt(bookingId),

        witnessName: witnessName.trim() || null,

        witnessSignature: isWitnessSigEmpty ? null : witnessSig,

        guestSignature: isGuestSigEmpty ? null : guestSig,

      };



      const result = await signBookingConsent(consentData);

      if (result.isSuccess) {

        Swal.fire("Success", result.message || "Consent signed successfully", "success").then(() => {

          // Notify parent window to refresh booking list

          if (window.opener && !window.opener.closed) {

            try {

              // Send message to parent window to refresh bookings

              window.opener.postMessage({ type: 'CONSENT_SIGNED', bookingId: parseInt(bookingId) }, window.location.origin);

            } catch (error) {

              console.error("Error communicating with parent window:", error);

            }

          }

          // Close the tab

          window.close();

        });

      } else {

        Swal.fire("Error", result.message || "Failed to sign consent", "error");

      }

    } catch (error) {

      console.error('Error signing consent:', error);

      Swal.fire("Error", error.response?.data?.message || "Failed to sign consent", "error");

    } finally {

      setLoading(false);

    }

  };



  const handleClose = () => {

    window.close();

  };



  const formattedConsentDate = consentSignedDate

    ? new Date(consentSignedDate).toLocaleDateString('en-GB', {

        day: '2-digit',

        month: '2-digit',

        year: 'numeric',

      })

    : new Date().toLocaleDateString('en-GB', {

        day: '2-digit',

        month: '2-digit',

        year: 'numeric',

      });



  if (pageLoading) {

    return (

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

        <ClipLoader size={50} color="#007bff" />

      </div>

    );

  }



  return (

    <React.Fragment>

      <div className="page-content">

        <Container fluid>

          <Breadcrumb title="Consent Form" breadcrumbItem={isConsentSigned ? "General Consent Form (Signed)" : "General Consent Form"} />

          

          <Card>

            <CardHeader style={{ backgroundColor: '#2d2d2d', color: '#ffffff', borderBottom: '1px solid #555' }}>

              <div className="d-flex justify-content-between align-items-center">

                <h4 className="mb-0">{isConsentSigned ? 'General Consent Form (Signed)' : 'General Consent Form'}</h4>

                <Button color="secondary" onClick={handleClose}>

                  Close

                </Button>

              </div>

            </CardHeader>

            <CardBody style={{ backgroundColor: '#2d2d2d', color: '#ffffff' }}>

              <div style={{

                backgroundColor: '#2d2d2d',

                color: '#ffffff',

                padding: '20px',

                borderRadius: '8px',

                marginBottom: '20px'

              }}>

                <h4 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' }}>

                  GENERAL CONSENT FORM

                </h4>



                <div style={{ marginBottom: '15px', fontWeight: 'bold', textAlign: 'center' }}>

                  DO NOT SIGN THIS FORM WITHOUT READING AND UNDERSTANDING ITS CONTENTS

                </div>



                <Row className="mb-3">

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Guest Name:</Label>

                      <Input

                        type="text"

                        value={customerName || ''}

                        readOnly

                        style={{ backgroundColor: '#3d3d3d', color: '#ffffff', border: '1px solid #555' }}

                      />

                    </FormGroup>

                  </Col>

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Mobile No:</Label>

                      <Input

                        type="text"

                        value={customerMobile || ''}

                        readOnly

                        style={{ backgroundColor: '#3d3d3d', color: '#ffffff', border: '1px solid #555' }}

                      />

                    </FormGroup>

                  </Col>

                </Row>



                <div style={{ fontSize: '12px', lineHeight: '1.6', marginBottom: '20px' }}>

                  <p><strong>1.</strong> The nature of the service procedure has been explained to me and I understand that just as there may be benefits from the procedure, all procedures involve risk to some degree.</p>

                  <p><strong>2.</strong> The guests should pay the spa service fee upon check-in. All services rendered are final and are not refundable. If a customer has unused appointments/sessions for individual services, service packages, or service series, that service only will be re-scheduled as per the available slots.</p>

                  <p><strong>3.</strong> Upon check-in, all guests are requested to provide valid identification documents and should declare all allergies to food and beauty products along with any current medical conditions that they are receiving treatment to Annyeong Spa reception. Pregnant guest should consult their doctors before using spa services. Guests in their menstrual period are requested not to enter the wet area due to hygienic reasons.</p>

                  <p><strong>4.</strong> Guest under the age of 16 years is not allowed to use spa service and guests under 18 will be admitted if under supervision. Consumption of alcohol and smoking is prohibited inside the spa. Guests under the influence of alcohol are not permitted inside the facility. No pets are allowed in the spa area. The Korean spa capsule may cause claustrophobic feelings, so guests with history of claustrophobia (fear of closed space) are discouraged to use Korean Spa Capsules.</p>

                  <p><strong>5.</strong> Guests should stick to the recommended time indicated in the package that they have availed, in using the facilities.</p>

                  <p><strong>6.</strong> Upon Check-in, all guests are provided with a locker facility with an electronic key to keep their belongings at their sole responsibility and Annyeong Spa management are not liable for any missing items from the locker. The electronic key can be always worn, including in the wet area, and they can carry their mobile phones for personal use with the waterproof pouches provided. Upon check-out, guests can hand over their electronic keys with wristbands and get their valid IDs back from the reception. If guests failed to surrender Annyeong Spa assets which came to their possession during the use of service or given to them upon check in should be returned upon check out. Penalty will be applied for missing items (if any).</p>

                  <p><strong>7.</strong> The guests should follow the sequence of the package that they have availed. It is recommended to exercise caution on wet surfaces inside the shower area and all other areas, as slippery surfaces are a high fall risk. Upon entering spa area, guests should remove their shoes and keep them in the shoe rack. Before entering the wet area, guests should take a shower in the designated area. Guests are allowed to wear slippers except in the wet area and are provided with Spa slippers. The guests should wear the disposable undergarments that were given to them before entering the wet area.</p>

                  <p><strong>8.</strong> The guests should not manipulate or change settings of the facilities inside the wet area such as Sauna, Steam, Jacuzzi, Korean Shower etc. Also avoid touching hot surfaces such as the hot stone or any other metallic surfaces in the sauna and steam. For assistance, guests may contact the technician. All guests should remove their contact lenses while using hot water services.</p>

                  <p><strong>9.</strong> The guests are asked to leave the steam and sauna immediately if they are feeling dizzy, tired, or uncomfortable. To alert the staff, ring the bell provided. Prior to using the sauna, steam, and hot tubs, all guests should ensure that they are adequately hydrated. Packaged drinking water will be provided upon entry and upon request.</p>

                  <p><strong>10.</strong> Only 2 persons are allowed to enter the sauna at the same time. The same goes for steam rooms and infrared sauna. In case of an emergency, guests should ring the emergency bell or notify the attending staff using the bell provided.</p>

                  <p><strong>11.</strong> Before entering the dry area, the guests should wear the spa uniform including the Korean lamb head towel.</p>

                  <p><strong>12.</strong> Guests may receive a complimentary from depending on the packages/services they have availed.</p>

                </div>



                <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#3d3d3d', borderRadius: '5px' }}>

                  <p style={{ marginBottom: '10px' }}>

                    <strong>I hereby declare that I have read and understood all terms and conditions indicated in this document and I confirm that I do my consent in every point made.</strong>

                  </p>

                </div>



                <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#3d3d3d', borderRadius: '5px' }}>

                  <p style={{ fontSize: '12px', marginBottom: '10px' }}>

                    <strong>Consent for Marketing Communication</strong>

                  </p>

                  <p style={{ fontSize: '12px', marginBottom: '10px' }}>

                    I hereby give my consent to receive marketing communication from Annyeong Spa and Beauty Center LLC through the email address and mobile number provided. This includes promotional offers, appointment reminders, service updates, and loyalty program notifications. I understand that I may withdraw my consent at any time by notifying the spa or opting out through the provided communication channels.

                  </p>

                </div>



                {isConsentSigned && consentSignedDate && (

                  <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#1a5a1a', borderRadius: '5px', textAlign: 'center' }}>

                    <strong>Signed on: {formattedConsentDate}</strong>

                  </div>

                )}



                <Row>

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Guest Signature {!isConsentSigned && <span className="text-danger">*</span>}</Label>

                      <div style={{ border: '2px solid #555', borderRadius: '5px', padding: '10px', backgroundColor: '#ffffff' }}>

                        <canvas

                          ref={guestCanvasRef}

                          width={300}

                          height={150}

                          style={{

                            border: '1px solid #ccc',

                            cursor: isConsentSigned ? 'default' : 'crosshair',

                            display: 'block',

                            width: '100%',

                            maxWidth: '300px'

                          }}

                          onMouseDown={(e) => startDrawing(e, true)}

                          onMouseMove={(e) => draw(e, true)}

                          onMouseUp={() => stopDrawing(true)}

                          onMouseLeave={() => stopDrawing(true)}

                          onTouchStart={(e) => {

                            e.preventDefault();

                            const touch = e.touches[0];

                            const mouseEvent = new MouseEvent('mousedown', {

                              clientX: touch.clientX,

                              clientY: touch.clientY

                            });

                            startDrawing(mouseEvent, true);

                          }}

                          onTouchMove={(e) => {

                            e.preventDefault();

                            const touch = e.touches[0];

                            const mouseEvent = new MouseEvent('mousemove', {

                              clientX: touch.clientX,

                              clientY: touch.clientY

                            });

                            draw(mouseEvent, true);

                          }}

                          onTouchEnd={() => stopDrawing(true)}

                        />

                      </div>

                      {!isConsentSigned && (

                        <Button

                          color="secondary"

                          size="sm"

                          onClick={() => clearSignature(true)}

                          style={{ marginTop: '5px' }}

                        >

                          Clear Guest Signature

                        </Button>

                      )}

                    </FormGroup>

                  </Col>

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Witness Signature</Label>

                      <div style={{ border: '2px solid #555', borderRadius: '5px', padding: '10px', backgroundColor: '#ffffff' }}>

                        <canvas

                          ref={witnessCanvasRef}

                          width={300}

                          height={150}

                          style={{

                            border: '1px solid #ccc',

                            cursor: isConsentSigned ? 'default' : 'crosshair',

                            display: 'block',

                            width: '100%',

                            maxWidth: '300px'

                          }}

                          onMouseDown={(e) => startDrawing(e, false)}

                          onMouseMove={(e) => draw(e, false)}

                          onMouseUp={() => stopDrawing(false)}

                          onMouseLeave={() => stopDrawing(false)}

                          onTouchStart={(e) => {

                            e.preventDefault();

                            const touch = e.touches[0];

                            const mouseEvent = new MouseEvent('mousedown', {

                              clientX: touch.clientX,

                              clientY: touch.clientY

                            });

                            startDrawing(mouseEvent, false);

                          }}

                          onTouchMove={(e) => {

                            e.preventDefault();

                            const touch = e.touches[0];

                            const mouseEvent = new MouseEvent('mousemove', {

                              clientX: touch.clientX,

                              clientY: touch.clientY

                            });

                            draw(mouseEvent, false);

                          }}

                          onTouchEnd={() => stopDrawing(false)}

                        />

                      </div>

                      {!isConsentSigned && (

                        <Button

                          color="secondary"

                          size="sm"

                          onClick={() => clearSignature(false)}

                          style={{ marginTop: '5px' }}

                        >

                          Clear Witness Signature

                        </Button>

                      )}

                    </FormGroup>

                  </Col>

                </Row>



                <Row className="mb-3">

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Date of Consent:</Label>

                      <Input

                        type="text"

                        value={formattedConsentDate}

                        readOnly

                        style={{ backgroundColor: '#3d3d3d', color: '#ffffff', border: '1px solid #555' }}

                      />

                    </FormGroup>

                  </Col>

                  <Col md={6}>

                    <FormGroup>

                      <Label style={{ color: '#ffffff' }}>Witness Name:</Label>

                      <Input

                        type="text"

                        value={witnessName}

                        onChange={(e) => setWitnessName(e.target.value)}

                        readOnly={isConsentSigned || isWitnessNameReadOnly}

                        placeholder="Enter witness name"

                        style={{ backgroundColor: (isConsentSigned || isWitnessNameReadOnly) ? '#3d3d3d' : '#ffffff', color: (isConsentSigned || isWitnessNameReadOnly) ? '#ffffff' : '#000000', border: '1px solid #555' }}

                      />

                    </FormGroup>

                  </Col>

                </Row>



                <div className="text-center mt-4">

                  <Button color="secondary" onClick={handleClose} className="me-2">

                    Close

                  </Button>

                  {!isConsentSigned && (

                    <Button color="primary" onClick={handleSign} disabled={loading}>

                      {loading ? <ClipLoader size={16} color="#fff" /> : "Sign Consent"}

                    </Button>

                  )}

                </div>

              </div>

            </CardBody>

          </Card>

        </Container>

      </div>

    </React.Fragment>

  );

};



export default ConsentFormPage;
